/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { useEffect, useState } from 'react';
import './style.scss';
import { Avatar } from '@g17eco/atoms/avatar';
import { FileDropZone } from '../files/FileDropZone';
import { DropzoneOptions, FileRejection } from 'react-dropzone';
import { saveReportingLevelDetails } from '../../actions/initiative';
import { useAppDispatch } from '@reducers/index';

interface PreviewParams {
  defaultPicture?: string;
  files?: { preview: string }[];
  width?: string;
  onClearFiles?: () => void;
}

export type PreviewFn = (props: PreviewParams) => JSX.Element;

const preview: PreviewFn = ({ files, width }) => {
  if (!Array.isArray(files) || files.length === 0) {
    return (
      <div className='company-logo__dropzone'>
        <div className='d-flex flex-column align-items-center'>
          <i className='fal fa-image'></i>
          <div className='btn btn-link'>Add logo</div>
        </div>
      </div>
    );
  }

  const [file] = files;
  return (
    <div className='company-logo__dropzone'>
      <Avatar width={width ? width : '100px'}>{file ? <img alt='avatar' src={file.preview} /> : <></>}</Avatar>
    </div>
  );
};

interface ProfileLogoProps extends Pick<DropzoneOptions, 'maxSize'> {
  initiativeId: string;
  defaultPicture?: string;
}

const accept = { 'image/*': [] };

export const ProfileLogo = (props: ProfileLogoProps) => {
  const dispatch = useAppDispatch();
  const { initiativeId, defaultPicture } = props;
  const [files, setFiles] = useState<{ preview: string }[]>(defaultPicture ? [{ preview: defaultPicture }] : []);
  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );
  const handleFilesAdded = (files: File[]) => {
    const formData = { files };
    dispatch(saveReportingLevelDetails(initiativeId, formData));
  };
  const onDrop = (files: File[], _fileRejections: FileRejection[]) => {
    setFiles(
      files.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
    handleFilesAdded(files);
  };

  return (
    <div className='ProfilePicture w-100'>
      <FileDropZone multiple={false} accept={accept} onDrop={onDrop} {...props}>
        {preview({ files })}
      </FileDropZone>
    </div>
  );
};
